import React from 'react'

import { useCart } from '@/entities/cart'

import { BASE_URL, PRODUCT_URL } from '@/shared/lib/const/env'
import { ACCESSORIES_BENEFIT_PERCENT, SECTION_ID_WITHOUT_BENEFITS } from '@/shared/lib/const/sections'
import { TAccessories } from '@/shared/types/product-types'
import { Popover } from '@/shared/ui'

import { useAppliedAccessories } from '../../../hooks/use-applied-accessories'
import { AccessoriesSection } from '../../accessories-section/accessories-section'
import { BasketItemTable } from '../../basket-item-table/basket-item-table'

import cl from './applied-accessories-section.module.scss'

export type AppliedAccessoriesSectionProps = {
	productId: number
	sectionId: number
	accessories: TAccessories
}

/**
 * Компонент секции аксессуаров для товара в корзине
 * Отображает селектор доступных аксессуаров и список примененных
 */
export const AppliedAccessoriesSection = ({
	productId,
	sectionId,
	accessories
}: AppliedAccessoriesSectionProps): JSX.Element | null => {
	const { changeCount, deleteItem } = useCart()
	const { appliedAccessories } = useAppliedAccessories(productId)

	const accessoryList = React.useMemo(() => (accessories ? Object.values(accessories) : []), [accessories])

	const showBenefitBadge = sectionId.toString() !== SECTION_ID_WITHOUT_BENEFITS.toString()

	if (!accessoryList?.length) {
		return null
	}

	return (
		<section className={cl.accessoriesSection} aria-label="Аксессуары к товару">
			{showBenefitBadge && (
				<div className={cl.benefitBadge}>
					<Popover
						trigger="hover"
						overlayClassName="serviceTooltip"
						content="Выгода действует при покупке в комплекте"
						placement="bottom">
						<span className={cl.benefitText}>с выгодой {ACCESSORIES_BENEFIT_PERCENT}%</span>
					</Popover>
				</div>
			)}

			<AccessoriesSection title="Добавить аксессуар" items={accessoryList} relId={productId} />

			{appliedAccessories.map(accessory => {
				const { ID, TITLE, PRICE, KOD, IMAGE, QUANTITY, ID_BASKET, BONUS, ORDER_TYPE } = accessory

				return (
					<BasketItemTable
						key={KOD}
						productCode={KOD}
						ariaLabel="Информация об аксессуаре"
						title={TITLE}
						link={PRODUCT_URL + KOD}
						imageSrc={IMAGE ? BASE_URL + IMAGE : `/product-image-placeholder.jpeg`}
						price={PRICE}
						initialCount={QUANTITY}
						idBasket={ID_BASKET}
						productId={ID}
						bonus={BONUS}
						onQuantityChange={changeCount}
						onDeleteButtonClick={deleteItem}
						orderType={ORDER_TYPE}
					/>
				)
			})}
		</section>
	)
}
